import { Injectable } from '@angular/core';
import { MasterHelpModel } from '../models/MasterHelp.model';
import { EngagementService } from 'src/app/services/engagement.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class Sharedservice {
  public menuClick: boolean;
  public isSessionExpired: boolean;
  public engagementMenuClicked: boolean = false;
  public homeMenuClicked: boolean = true;
  public helpMenuClicked: boolean = false;
  public reportsMenuClicked: boolean = false;
  public customizedlayoutMenuClicked: boolean = false;
  public activeEngagementName: string = '';
  public activePaceId: string = '';
  public index: number;
  engagementId = +this.route.snapshot.paramMap.get('id');
  loggedInUserId: number;
  helpMenu1: MasterHelpModel = new MasterHelpModel();

  constructor(private engagementservice: EngagementService, private router: Router, private route: ActivatedRoute) { }

  engagementMenuClick(engagementName?: string, paceId?: string) {
    localStorage.setItem('activeEngName', engagementName);
    localStorage.setItem('activePaceId', paceId);
    this.engagementMenuClicked = true;
    this.homeMenuClicked = false;
    this.helpMenuClicked = false;
    this.activeEngagementName = engagementName;
    this.activePaceId = paceId;
    this.reportsMenuClicked = false;
    this.customizedlayoutMenuClicked = false;
  }

  homeMenuClick() {
    this.engagementMenuClicked = false;
    this.homeMenuClicked = true;
    this.helpMenuClicked = false;
    this.reportsMenuClicked = false;
    this.customizedlayoutMenuClicked = false;
  }

  reportsMenuClick() {
    this.engagementMenuClicked = false;
    this.homeMenuClicked = false;
    this.helpMenuClicked = false;
    this.reportsMenuClicked = true;
    this.customizedlayoutMenuClicked = false;
  }

  helpMenuClick() {
    this.engagementMenuClicked = false;
    this.homeMenuClicked = false;
    this.helpMenuClicked = true;
    this.reportsMenuClicked = false;
    this.customizedlayoutMenuClicked = false;
  }

  customizedLayoutMenuClick() {
    this.engagementMenuClicked = false;
    this.homeMenuClicked = false;
    this.helpMenuClicked = false;
    this.reportsMenuClicked = false;
    this.customizedlayoutMenuClicked = true;
  }

  setactiveindex(indexName?: number) {
    localStorage.setItem('activeindex', indexName.toString());
  }

  getLocalStorageValueByName(indexName: string) {
    return +localStorage.getItem(indexName);
  }

  getLocalStorageValueByValue(indexName: string) {
    return localStorage.getItem(indexName.toString());
  }

  CheckUserAccessForEngagement(engagementId: number) {
    this.engagementservice.CheckUserAccessForEngagement(engagementId).subscribe(data => {
      const engagementAccessflag = <number>data;
      if (engagementAccessflag == 0) {
        this.router.navigate(['unauthorize'], { queryParams: { redirectFrom: 'engagement' } });
      }
    }, error => {
      if (error.status === 401) {
        this.router.navigate(['unauthorize'], { queryParams: { redirectFrom: 'engagement' } });
      }
    });
  }

  validateDateWithRegex(dates, regionId, key) {
    var reg1 = /[A-Za-z]{3}-[0-9]{2}/;
    var reg2 = /[A-Za-z]{3}[0-9]{2}/;
    var reg21 = /[A-Za-z]{3} [0-9]{2}, [0-9]{2,4}$/; //January 31, 2019
    var reg22 = /[0-9]{2} [A-Za-z]{3,9} [0-9]{2,4}/; // 31 January 2019
    var reg3 = /[A-Za-z]{3} [0-9]{2}/;
    var reg4 = /[0-9]{2}[A-Za-z]{3}/;
    var reg5 = /[0-9]{2} [A-Za-z]{3}/;
    var reg6 = /[0-9]{2}-[A-Za-z]{3}/;
    var reg7 = /[A-Za-z]{3}'[0-9]{2}/;
    var reg8 = /[A-Za-z]{3}[,.;\[\]{}=+()^%$#@!`]{1} [0-9]{2}/;
    var reg9 = /[A-Za-z]{3}[,.;\[\]{}=+()^%$#@!`]{1}[0-9]{2}/;
    var reg10 = /^[0-9]{4}$/;
    var reg11 = /^[0-9]{1,2}[.\-/]{1}[0-9]{1,2}[.\-/]{1}[0-9]{2,4}/;
    var reg12 = /^[0-9]{2}-[0-9]{4}$/;
    var reg13 = /^[0-9]{2}$/;
    var reg14 = /\b([J,j]an(?:uary)?|[F,f]eb(?:ruary)?|[M,m]ar(?:ch)?|[A,a]pr(?:il)?|[M,m]ay|[J,j]un(?:e)?|[J,j]ul(?:y)?|[A,a]ug(?:ust)?|[S,s]ep(?:tember)?|[O,o]ct(?:ober)?|[N,n]ov(?:ember)?|[D,d]ec(?:ember)?)$/i;
    var reg15 = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    var reg16 = /(^0?[1-9]$)|(^1[0-2]$)/;
    var d = dates;
    var returnDateArray = [0, 0];
    if (reg1.test(d)) {
      var mon = d.substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[0]];
    }
    else if (reg2.test(d)) {
      var mon = d.substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[0]];
    }
    else if (reg21.test(d)) {
      var mon = d.substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[1]];
    }
    else if (reg22.test(d)) {
      let dateArray = d.split(' ');
      var mon = dateArray[1].substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      returnDateArray = [m, parseInt(dateArray[2])];
    }
    else if (reg3.test(d)) {
      var mon = d.substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[0]];
    }
    else if (reg4.test(d)) {
      var a = parseInt(d)
      var answer = '5A';
      answer = d.replace(/[0-9]/g, '');
      if (answer.length < 4) {
        var mon22 = answer.charAt(0).toUpperCase();
        var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon22) / 3 + 1;
      }
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[0]];
    }
    else if (reg5.test(d)) {
      var m5;
      var a = parseInt(d)
      var answer5 = d.replace(/[0-9]/g, '');
      answer5 = answer5.replace(/\s/g, '');
      if (answer5.length < 4) {
        var mon5 = answer5.charAt(0).toUpperCase();
        m5 = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon5) / 3 + 1;
      }
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m5, numbers[0]];
    }
    else if (reg6.test(d)) {
      var m6;
      var a = parseInt(d)
      var answer6 = d.replace(/[0-9]/g, '');
      answer6 = answer6.replace(/[^\w\s]/gi, '')
      if (answer6.length < 4) {
        var mon6 = answer6.charAt(0).toUpperCase();
        m6 = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon6) / 3 + 1;
      }
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m6, numbers[0]];
    }
    else if (reg7.test(d)) {
      var mon7 = d.substring(0, 3);
      var mon7 = mon7.charAt(0).toUpperCase();
      var m7 = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon7) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m7, numbers[0]];
    }
    else if (reg8.test(d) || reg9.test(d)) { //Dec.*{2019 - all valid filename as per windows
      var mon = d.substring(0, 3);
      var mon2 = mon.charAt(0).toUpperCase();
      var m = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mon2) / 3 + 1;
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [m, numbers[0]];
    }
    else if (reg10.test(d)) { //Only year - 2019 and NOT 19 - return default December
      returnDateArray = [0, parseInt(d)]
    }
    else if (reg11.test(d)) {
      var numbers = d.match(/\d+/g).map(Number);
      var year = numbers[2]
      var month = 1;
      if (regionId === 1) // for US :- mm./-dd./-yyyy | yy
      {
        month = numbers[0]
      }
      else { // for ROW :- dd./-mm./-yyyy | yy
        month = numbers[1]
      }
      returnDateArray = [month, year];
    }
    else if (reg12.test(d)) {
      var numbers = d.match(/\d+/g).map(Number);
      returnDateArray = [numbers[0], numbers[1]];
    }
    else if (reg13.test(d)) { //Only year of two digit
      if (key == 'periodPreviewYear') {
        returnDateArray = [0, parseInt(d)]
      }
      else if (key == 'periodPreview') {
        if (reg16.test(d)) {
          returnDateArray = [1, 0]
        }
      }
    }
    else if (reg14.test(d)) { //Only year - 2019 and NOT 19 - return default December
      if (reg15.test(d)) {
        returnDateArray = [1, 1]
      }
      else if (/\d/.test(d)) {
        var numbers = d.match(/\d+/g).map(Number);
        returnDateArray = [12, numbers]
      }
      else
        returnDateArray = [1, 0]
    }
    else if (reg16.test(d)) {
      returnDateArray = [1, 0]
    }

    if (key == 'periodPreviewYear') {
      return (!(returnDateArray[0] === undefined || returnDateArray[0] === 0 || returnDateArray[0] < 0)
        || (returnDateArray[1] === undefined || returnDateArray[1] === 0 || returnDateArray[1] < 0));
    }
    else if (key == 'periodPreview') {
      return ((returnDateArray[0] === undefined || returnDateArray[0] === 0 || returnDateArray[0] < 0)
        || !(returnDateArray[1] === undefined || returnDateArray[1] === 0 || returnDateArray[1] < 0));
    }
    else {
      return ((returnDateArray[0] === undefined || returnDateArray[0] === 0 || returnDateArray[0] < 0)
        || (returnDateArray[1] === undefined || returnDateArray[1] === 0 || returnDateArray[1] < 0));
    }
  }

  // Logic for P445 end date validation
  validateEndDateWithRegex(date: any, regionId: any, key: any) {
    let endDateFalg = true;
    let val = /^(?:(0[1-9]|1[012])[\/.](0[1-9]|[12][0-9]|3[01])[\/.](19|20)[0-9]{2})$/; //mm/dd/yyyy
    let val2 = /^(?:(0[1-9]|1[012])[\/.](0[1-9]|[12][0-9]|3[01])[\/.](19|20)[0-9]{0})$/;//mm/dd/yy
    let val3 = /^(?:(0[1-9]|1[012])[-.](0[1-9]|[12][0-9]|3[01])[-.](19|20)[0-9]{2})$/; //mm-dd-yyyy
    let val4 = /^(?:(0[1-9]|1[012])[-.](0[1-9]|[12][0-9]|3[01])[-.](19|20)[0-9]{0})$/;//mm-dd-yyyy
    let val5 = /^(([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])(-)(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(-)((19|20)\d{0}))$/i; //dd-mmm-yyyy
    let val6 = /^(([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])(-)(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(-)((19|20)\d{2}))$/i; //dd-mmm-yy
    let val7 = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/; //dd/mm/yyyy
    let val8 = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{2}$/; //dd/mm/yy
    let val9 = /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/; //dd-mm-yyyy
    let val10 = /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{2}$/; //dd-mm-yy

    // If months exceeds 12 throwing an error
    if (regionId !== 1) {
      if (val.test(date) || val2.test(date) || val3.test(date) || val4.test(date)) {
        let dateSplitValue = date.split('-');
        let dateSepartorValue = date.split('/')
        if (dateSplitValue[1] >= 13 || dateSepartorValue[1] >= 13) {
          endDateFalg = false;
        }
      } else {
        endDateFalg = true;
      }
    }
    else {
      if (val7.test(date) || val8.test(date) || val9.test(date) || val10.test(date)) {
        let dateSplitValue = date.split('-')
        let dateSepartorValue = date.split('/')
        if (dateSplitValue[1] >= 13 || dateSepartorValue[1] >= 13) {
          endDateFalg = false;
        }
      } else {
        endDateFalg = true;
      }
    }

    // Logic for end date format US,ROW & Other templates   
    if (regionId === 1) {
      if ((val.test(date) || val2.test(date) || val3.test(date) || val4.test(date) || val5.test(date) || val6.test(date) && !(val7).test(date) && !(val8.test(date))) && endDateFalg) {
        return false;
      } else {
        return true;
      }
    } else {
      if ((val5.test(date) || val6.test(date) || val7.test(date) || val8.test(date) || val9.test(date) || val10.test(date)) && endDateFalg) {
        return false
      } else {
        return true;
      }
    }
  }
}
